import React, { useContext, useEffect, useState } from "react"

import { GlobalAuthContext } from "../../context/authContext"

import JobPostingForm from "../../components/company-profile/job-posting"
import CompanyProfileLayout from "../../components/layout/company-profile"
import Spinner from "../../components/spinner/spinner"
import { FETCH_INDUSTRY_SKILLS } from "../../components/company-profile/job-posting/jobActions"
import { FETCH_JOB_DETAILS } from "../../components/job/job-actions"

const JobPostingPage = ({ slug }) => {
  const [jobDetails, setJobDetails] = useState(null)
  const [loading, setLoading] = useState(true)
  const { state, dispatch } = useContext(GlobalAuthContext)

  const fetchJobDetails = async () => {
    if (slug) {
      setLoading(true)
      const res = await FETCH_JOB_DETAILS(slug)
      setJobDetails(res)
      setLoading(false)
    } else {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchJobDetails()
    if (state?.profile && !state?.industry_skills) {
      FETCH_INDUSTRY_SKILLS("", dispatch)
    }
  }, [state?.profile]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <CompanyProfileLayout
      title="Post Job"
      menu={[]}
      sidebarMenu={[]}
      activeSidebar="Jobs"
      active="Post Job"
      subText="Lorem Ipsum dol setiin apetite abcd in my of full"
    >
      {!loading &&
      !!state?.config &&
      !!state?.profile &&
      state?.company_data &&
      state?.industry_skills ? (
        <JobPostingForm data={jobDetails} />
      ) : (
        <Spinner />
      )}
    </CompanyProfileLayout>
  )
}

export default JobPostingPage
